import { Language } from '../../../enums/const-enums';

export interface RassOobTranslations {
  notifications: {
    intro_1: string;
    intro_2: string;
    help_desk: {
      phone_helpdesk_fl: string;
      phone_helpdesk_none: string;
      phone_helpdesk_pro: string;
      phone_helpdesk_rn: string;
    };
  };
}

const nlTranslations: RassOobTranslations = {
  notifications: {
    intro_1:
      'Controleer bovenstaande samenvatting goed. Klopt alles? Vul dan als extra controle de bevestigingscode in. Deze code ontvang je per sms-bericht op het telefoonnummer <strong>',
    intro_2:
      '</strong><br><br>Dit is het telefoonnummer dat je hebt opgegeven voor het ontvangen van beveiligingsberichten. Gaat er iets mis bij het ondertekenen? ',
    help_desk: {
      phone_helpdesk_fl: 'Bel dan +31(0)30 71 21777.',
      phone_helpdesk_none: 'Neem dan contact op met de helpdesk.',
      phone_helpdesk_pro:
        'Bel dan 0900-9270 of +31 887 226 622 vanuit het buitenland.',
      phone_helpdesk_rn:
        'Bel dan 0900-0905 of +31 887 226 627 vanuit het buitenland.',
    },
  },
};

const enTranslations: RassOobTranslations = {
  notifications: {
    intro_1:
      'Check the summary above thoroughly. If everything is correct, enter the confirmation code as an additional check. You will receive this code in a text message on phone number <strong>',
    intro_2:
      '</strong><br><br>This is the phone number that you have registered with us. Are you encountering any difficulties? ',
    help_desk: {
      phone_helpdesk_fl: 'Then please call +31(0)30 71 21777.',
      phone_helpdesk_none: 'Then please contact the help desk.',
      phone_helpdesk_pro:
        'Then please call 0900-9270 or +31 887 226 622 from abroad.',
      phone_helpdesk_rn:
        'Then please call 0900-0905 or +31 887 226 627 from abroad.',
    },
  },
};

export const rassOobTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: enTranslations,
  [Language.PT]: enTranslations,
};
